import { render } from "./IconMenuTimeTable.vue?vue&type=template&id=5d3dcbd0"
import script from "./IconMenuTimeTable.vue?vue&type=script&lang=ts"
export * from "./IconMenuTimeTable.vue?vue&type=script&lang=ts"
script.render = render

export default script